<template>
  <b-overlay :show="showOverview" no-center rounded="sm" opacity="1" variant="light">
    <AppSection
      id="question-form-page"
      :title="$getConst.pages.privacy_policy.privacy_policy_title"
      type="section"
      select-language
    >
      <b-form-group id="help-page-language" :label="$t($getConst.pages.language.list_of_language)" label-for="help-page-language-input">
        <multiselect
          class="border-right-0 border-left-0"
          v-model="language"
          track-by="id"
          label="name"
          :placeholder="$t(this.$getConst.pages.form.select_option)"
          :options="languages"
          :disabled="isSubmitting || isLoading"
          :allowEmpty="false"
          @input="getPrivacyPolicyContent"
        >
          <template slot="singleLabel" slot-scope="props">
            <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
            {{$t(props.option.name) | capitalize}}
          </template>
          <template slot="option" slot-scope="props">
            <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
            {{$t(props.option.name.toLowerCase()) | capitalize}}
          </template>
        </multiselect>
      </b-form-group>
      <AppSpinner
        v-if="isLoading"
        size="5"
        class="mx-auto mt-5 text-secondary"
      />
      <template v-else>
      <div style="text-align: center">
        <toggle-button
          class="border-right-0 border-left-0"
          v-model="isPDF"
          :margin="5"
          :width="80"
          :height="28"
          color="#00a0da"
          :value="isPDF"
          :sync="true"
          :labels="{checked: 'PDF', unchecked: 'TEXT'}"/>
      </div>
      <vue-editor
        v-if="!isLoading && !isPDF"
        :disabled="isSubmitting"
        :customModules="customModulesForEditor"
        :editorOptions="editorSettings"
        :editorToolbar="toolbarOptions"
        v-model.trim="$v.privacyPolicyToEdit.$model"
        :class="{ 'is-invalid': $v.privacyPolicyToEdit.$error }"
      />
      <AppFormFeedback :errors="$v.privacyPolicyToEdit"/>
      <br>
      <AppFormFileInput
        v-if="isPDF"
        v-model="files"
        class="mx-auto py-0 flex-column d-flex"
        label="Upload supporting files"
        :onlyPdf="true"
        :multipleFile="false"
        @input="inputFileRecive"
        :timesheetAttachements="oldAttachments"
      />

        <a
          id="overview-button"
          type="button"
          class="d-block text-center text-uppercase font-weight-bold text-secondary pt-3"
          v-if="!isPDF"
          @click="showOverview = !showOverview"
        >
          {{$getConst.pages.privacy_policy.privacy_policy_overview | capitalize}}
        </a>

      <AppConfirmButtons
        v-if="hasWritePermission"
        :cancel-text="$getConst.pages.button.cancel_changes"
        :is-loading="isSubmitting"
        @onSubmit="onSave"
        @onCancel="onReset"
      />
      </template>

    </AppSection>
    <template #overlay>
      <AppSection
        id="help-page-overview"
        type="section"
        title="overview"
        class="p-2"
        @onClick="showOverview = !showOverview"
      >
        <template v-slot:button>
          <b-button
            class="ml-auto border-0 py-0 font-size-xxl"
            variant="dark-outline"
            @click="showOverview = !showOverview"
          >
            X
          </b-button>
        </template>
        <div v-html="privacyPolicyToEdit"/>
      </AppSection>
    </template>
  </b-overlay>
</template>

<script>
  import AppSection from "../../../../../components/common/sections/AppSection";
  import {VueEditor} from "vue2-editor";
  import ImageResize from "quill-image-resize-vue";
  import { required } from "vuelidate/lib/validators";
  import AppConfirmButtons from "../../../../../components/common/utils/AppConfirmButtons";
  import AppFormFeedback from "../../../../../components/common/form/AppFormFeedback";
  import AppSpinner from "../../../../../components/common/utils/AppSpinner";
  import {
    getPoliciesWithScope,
    getTermsOrPrivacyPolicyByScopeLanguage,
    updateTermsOrPrivacyPolicyContent
  } from "../../../../../api/policies.api";
  import AppFormFileInput from "../../../../../components/common/form/AppFormFileInput";
  export default {
    name: "editPrivacyPolicy",
    components: {AppFormFileInput, AppSpinner, AppFormFeedback, AppConfirmButtons, AppSection, VueEditor},
    props: {
      scope_id: null
    },
    data() {
      return {
        isPDF: null,
        oldAttachments: [],
        files: [],
        customModulesForEditor: [{ alias: "imageResize", module: ImageResize }],
        toolbarOptions: [
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'script': 'sub'}, { 'script': 'super' }],
          [{ 'color': ['#3c4b64','#002776','#00a0da','#e55353','#80379b','#28a745','#e98300'] }],
          ['link', 'image', 'video']
        ],
        editorSettings: {
          modules: {
            imageResize: {}
          }
        },

        showOverview: false,
        privacyPolicy: null,
        privacyPolicyToEdit: null,
        fileToEdit: null,
        languageFromSelect: null,
        language: null,
        languages: [],
        isLoading: false,
        isSubmitting: false,
        hasWritePermission: this.hasAnyOfPermissions(
          [this.$getConst.permissions.writePrivacyAndTerms]
        )
      }
    },
    validations() {
      if(this.isPDF){
        return{
          fileToEdit: {required},
          privacyPolicyToEdit: {}
        }
      }else{
        return{
          privacyPolicyToEdit: {required},
          fileToEdit: {}
        }
      }
    },
    methods: {
      inputFileRecive(files){
        if(files[0]){
          this.oldAttachments = [];
          this.fileToEdit = {'FileName': files[0].FileName, 'FileBase64': files[0].FileBase64};
        }
      },
      getPoliciesLanguages() {
        this.isLoading = true;
        this.languageFromSelect = null;
        getPoliciesWithScope(this.scope_id).then(
          (response) => {
            this.isLoading = false;
            this.languages = response.data;
            this.language = this.languages.find(lang => lang.hasOwnProperty("id_policy"));
            this.privacyPolicy = this.language.privacy_policy;

            if(this.privacyPolicy && this.privacyPolicy.includes('FileBase64')){
              this.isPDF = true;
              this.privacyPolicyToEdit = null;
              this.oldAttachments.push({
                'FileName':JSON.parse(this.privacyPolicy).FileName,
                'FileBase64':JSON.parse(this.privacyPolicy).FileBase64,
              });
            }else{
              this.isPDF = false;
              this.privacyPolicyToEdit = this.privacyPolicy;
              this.oldAttachments = [];
              this.fileToEdit = null;
            }

          },
          (error) => {
            this.handleApiError(error);
            this.isLoading = false;
          }
        )
      },
      getPrivacyPolicyContent(language) {
        this.isLoading = true;
        this.languageFromSelect = language;
        getTermsOrPrivacyPolicyByScopeLanguage(this.scope_id, language.id).then(
          (response) => {
            this.language = response.data[0];
            this.privacyPolicy = response.data[0].privacy_policy;
            this.isLoading = false;
            if(this.privacyPolicy && this.privacyPolicy.includes('FileBase64')){
              this.oldAttachments = [];
              this.isPDF = true;
              this.privacyPolicyToEdit = null;
              this.oldAttachments.push({
                'FileName':JSON.parse(this.privacyPolicy).FileName,
                'FileBase64':JSON.parse(this.privacyPolicy).FileBase64,
              });
            }else{
              this.isPDF = false;
              this.privacyPolicyToEdit = response.data[0].privacy_policy;
              this.oldAttachments = [];
              this.fileToEdit = null;
            }
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading = false;
          }
        )
      },
      onSave() {
        this.isSubmitting = true;
        let textToEdit;
        if(!this.isPDF){
          textToEdit = this.privacyPolicyToEdit;
        }else{
          textToEdit = this.fileToEdit;
        }
        updateTermsOrPrivacyPolicyContent(this.scope_id, this.language.id, {privacy_policy: textToEdit}).then(
          (response) => {
            if(!this.isPDF){
              this.fileToEdit = null;
              this.oldAttachments = [];
            }else{
              this.privacyPolicyToEdit=null;
            }
            this.privacyPolicy = response.data.privacy_policy;
            this.isSubmitting = false;
            this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
          },
          (error) => {
            this.handleApiError(error);
            this.isSubmitting = false;
          }
        );
      },
      onReset() {
        this.privacyPolicyToEdit = this.privacyPolicy;
      }
    },
    created() {
      this.getPoliciesLanguages();
    }
  }
</script>

<style scoped>

</style>
